<template>
  <div class="send">

    <md-dialog :md-active.sync="showEmailDialog">
      <md-dialog-title>{{
        emailDialogEditMode ? "Edit Email" : "Add Email"
      }}</md-dialog-title>
      <md-dialog-content>
        <form action="">
          <md-field>
            <label>Name</label>
            <md-input required v-model="emailDialogData.name"></md-input>
          </md-field>
          <md-field :class="validEmail() ? '' : 'md-invalid'">
            <label>Email</label>
            <md-input required v-model="emailDialogData.email" v-on:keyup="keymonitor"></md-input>
            <span class="md-error">Invalid email</span>
          </md-field>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showEmailDialog = false">Cancel</md-button>
        <md-button class="md-primary"
          :disabled="!emailDialogData.valid || !emailDialogData.email || !emailDialogData.name" @click="
            emailDialogEditMode ? editItem() : addItem(activeList, assignColor)
            ">{{ emailDialogEditMode ? "Save" : "Add" }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <h2 class="tab-title">{{ editTemplateId ? $t("Edit template") : $t("Create a transaction template") }}</h2>
    <div class="row">
      <div class="col-6 drag-super-cont">
        <div style="position: relative">

          <!-- <h3 style="opacity: 0.5; position: absolute; top: -15px; right: 0;">ID: 00348</h3> -->
        </div>

        <md-field>
          <label>Template name</label>
          <md-input v-model="templateData.description" required></md-input>
        </md-field>

        <!-- <div :class="'order-switch ' + (anyOrder ? 'any-order-switch' : '')">
          <span>{{ $t("Complete in order") }}</span>
          <md-switch v-model="anyOrder" class="md-primary">{{
            $t("Any order")
          }}</md-switch>
        </div> -->
        <md-field>
          <label>Number of initial approvers</label>
          <md-input v-model="templateData.approvers.initial" required type="number"></md-input>
        </md-field>

        <div style="position: relative; display: flex">
          <md-field>
            <label>Number of recipients</label>
            <md-input v-model="templateData.recipients" required type="number"></md-input>
          </md-field>
          <md-button class="md-icon-button md-primary" @click="
            setNames()
            ">
            <md-icon>assignment</md-icon>
            <md-tooltip md-direction="right" :md-active="timeTooltip" style="z-index: 5; transform: translateY(-30px)">Set
              recipient names</md-tooltip>
          </md-button>
        </div>
        <md-field>
          <label>Number of final approvers</label>
          <md-input v-model="templateData.approvers.final" required type="number"></md-input>
        </md-field>




        <div class=" ">
          <h3 class="cc-title">{{ $t("Suggested emails") }}</h3>

          <md-chips v-model="templateData.suggestions" :md-limit="5" :md-auto-insert="true"
            :md-placeholder="$t('Enter the emails')" :md-format="formatCC" :md-check-duplicated="true">
          </md-chips>
          <div style="position: relative">
            <h3 class="cc-title">{{ $t("Message") }}</h3>
            <md-button class="md-icon-button md-primary align-right-btn" style="position: absolute"
              @click="showDialog = true">
              <md-icon>lock</md-icon>
              <md-tooltip md-direction="left" :md-active="true" style="    z-index: 5;transform: translateY(-30px);">Set a
                password</md-tooltip>
            </md-button>
            <md-dialog :md-active.sync="showDialog">
              <md-dialog-title>Set Password</md-dialog-title>
              <div style="padding: 15px">
                <form action="" autocomplete="off">
                  <md-field>
                    <label>Password</label>
                    <md-input v-model="pw" type="password" autocomplete="off"></md-input>
                  </md-field>
                  <md-field>
                    <label>Confirm password</label>
                    <md-input v-model="co_pw" type="password" autocomplete="off"></md-input>
                  </md-field>
                </form>
                <div v-if="pw && (pw != co_pw)">Passwords must match</div>
              </div>
              <md-dialog-actions>
                <md-button class="md-primary" @click="showDialog = false">Close</md-button>
                <md-button class="md-primary" :disabled="pw && (pw != co_pw)"
                  @click="templateData.doc_password = pw; showDialog = false">Save</md-button>
              </md-dialog-actions>
            </md-dialog>
          </div>

          <md-field style="margin: 0">
            <label>Title</label>
            <md-input required v-model="templateData.title"></md-input>
          </md-field>
          <md-field style="margin-top: 20px">
            <md-textarea required placeholder="Please review and sign the attached document...*"
              v-model="templateData.message"></md-textarea>
          </md-field>
          <h3 class="cc-title">{{ $t("Files") }}</h3>
          <md-field :class="(singpdf === false) ? 'md-invalid' : ''">
            <label>{{ $t("Document to sign") }}</label>
            <md-file accept=".pdf" @md-change="onDocLoad($event)" required v-model="uploadModel" />
            <span class="md-error">Invalid file</span>
          </md-field>
          <md-field>
            <label>{{ $t("Terms & Conditions document") }}</label>
            <md-file accept=".pdf" @md-change="onTermsLoad($event)" />
          </md-field>
          <!-- <md-button class="md-raised md-primary align-right-btn"
          ><a class="contunue" href="http://localhost:8081">{{
            $t("Continue")
          }}</a></md-button
        > -->
          <!-- <md-button
          class="md-raised md-primary align-right-btn"
                    :disabled="
             !templateData.description ||
            !templateData.title ||
            !templateData.sign_document ||
            !templateData.message
          "
          @click="saveTemplate()"
          >{{ $t("Save template") }}</md-button
        > -->

          <md-button class="md-raised md-primary align-right-btn" :disabled="!templateData.description ||
            !templateData.title ||
            !templateData.sign_document ||
            !templateData.message
            " @click="saveTemplate(true)">{{ editTemplateId ? $t("Save and Edit Fields") : $t("Save and Add Fields")
  }}</md-button>
          <md-button class="md-raised md-primary align-right-btn" :disabled="!templateData.description ||
            !templateData.title ||
            !templateData.sign_document ||
            !templateData.message
            " @click="saveTemplate(false)">{{ $t("Save") }}</md-button>

          <md-button class="md-raised align-right-btn" @click="$router.push({ path: 'templateManager' })">{{ $t("Cancel")
          }}</md-button>
        </div>
      </div>

      <!-- Errors -->
      <md-snackbar md-position="center" :md-duration="3000" :md-active.sync="showError" md-persistent>
        <span>{{ errorMsg }}</span>
      </md-snackbar>

      <!-- /Errors -->

    </div>


    <md-dialog :md-active.sync="showDialogNames">
      <md-dialog-title>{{
        "Set names for recipients"
      }}</md-dialog-title>
      <div style="padding: 15px; overflow-y: auto;">
        <form action="" autocomplete="off">
          <div v-if="!templateData.recipients">Set at least one recipient</div>
          <md-field v-for="index in Number(templateData.recipients)" v-bind:key="index">
            <label>{{ "Recipient #" + index }}</label>
            <md-input autocomplete="off" v-model="templateData.recipientNames[index - 1]"></md-input>
          </md-field>

        </form>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialogNames = false">Done</md-button>

      </md-dialog-actions>
    </md-dialog>

  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
// import draggable from "vuedraggable";
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// const message = [""];
// const message2 = [""];
const message3 = [""];
export default {
  name: "Templates",
  display: "Transitions",
  order: 7,
  components: {
    // draggable,
  },
  data() {
    return {
      editTemplateId: null,
      uploadModel: null,
      templateData: {

        description: "",
        userId: Vue.prototype.$userData.user.id,

        approvers: {

          initial: 0,
          final: 0,
        },
        suggestions: [],
        recipients: 0,
        cc: [],
        in_order: false,
        doc_password: undefined,
        title: "",
        message: "",
        sign_document: null,
        tc_file: undefined,
        fields: [],
        recipientNames: [],
      },
      pw: '',
      co_pw: null,
      colors: [
        "#7CB9E8",
        "#9966CC",
        "#E52B50",
        "#F19CBB",
        "#3B7A57",
        "#FFBF00",
        "#FF7E00",
        "#841B2D",
        "#008000",
        "#007FFF",
        "#87421F",
      ],
      showError: false,
      showDoneDialog: false,
      errorMsg: '',
      showDialog: false,
      showEmailDialog: false,
      showDialogNames: false,
      singpdf: null,
      tcdoc: null,
      anyOrder: true,
      ccs: [],
      validCcs: [],
      emailDialogDataInit: null,
      emailDialogData: {
        name: "",
        email: "",
        valid: true
      },
      emailDialogEditMode: false,
      activeList: null,
      assignColor: false,
      list: [],
      list2: [],
      list3: [],
      list4: message3.map((name, index) => {
        return {
          name,
          order: index + 1,
          id: index + 1,
          email: [],
          valid: false,
        };
      }),
      drag: false,
    };
  },
  mounted() {
    const vm = this;
    vm.editTemplateId = vm.$route.query.templateId || null;
    if (vm.editTemplateId) {
      axios({
        method: "get",
        url: "/template/template",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization: "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          templateId: vm.editTemplateId
        }
      })
        .then((response) => {
          console.log("SUCCESS!!22");
          vm.templateData = response.data;
          vm.uploadModel = "Template document loaded";

        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    }
  },
  methods: {
    setNames() {
      this.showDialogNames = true;
      const aux = [];
      for (let index = 0; index < this.templateData.recipients; index++) {
        aux[index] = this.templateData.recipientNames[index] || 'User ' + (index + 1);
      }
      this.templateData.recipientNames = aux;


    },
    validEmail() {
      var emailDialogData = this.emailDialogData;
      emailDialogData.valid = emailRegex.test(emailDialogData.email);
      if (!emailDialogData.email) {
        return true;
      }
      return emailDialogData.valid;
    },
    getPermission(name) {
      const permissions = Vue.prototype.$userData.permissions|| [];
      if (!permissions.includes(name)) {
        this.$router.push("Landing");
      }
    },
    onTermsLoad(event) {
      const vm = this;
      vm.tcdoc = event[0];
      let formData = new FormData();
      formData.append("file", vm.tcdoc);

      axios({
        method: "post",
        url: "/sign/upload-file",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: formData,
      })
        .then((response) => {
          console.log("SUCCESS!!");

          vm.templateData.tc_file = response.data.fileId;
        })
        .catch(function () {
          console.log("FAILURE!!");

        });
    },
    onDocLoad(event) {
      const vm = this;
      vm.singpdf = event[0];
      let formData = new FormData();
      formData.append("file", vm.singpdf);

      axios({
        method: "post",
        url: "/sign/upload-file",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: formData,
      })
        .then((response) => {
          console.log("SUCCESS!!");

          vm.templateData.sign_document = response.data.fileId;
        })
        .catch(function () {
          console.log("FAILURE!!");
          vm.errorMsg = 'Cannot upload file!';
          vm.showError = true;
          vm.singpdf = false;
        });
    },

    keymonitor: function (event) {

      if (event.key == "Enter" && this.emailDialogData.valid && this.emailDialogData.email && this.emailDialogData.name) {
        this.emailDialogEditMode ? this.editItem() : this.addItem(this.activeList, this.assignColor)
      }
    },
    goToEdit() {
      const vm = this;
      // localStorage.setItem("transactionId",'');
      var fakeUsers = [];
      for (let index = 0; index < vm.templateData.recipients; index++) {
        fakeUsers.push({
          email: vm.templateData.recipientNames[index] || ('User ' + (index + 1))
        })

      }
      localStorage.setItem(
        "recipients",
        JSON.stringify(
          fakeUsers
        )
      );
      localStorage.setItem(
        "filepdf", vm.templateData.sign_document
      );

      //  vm.$router.push("edit");
      vm.$router.push({
        path: "edit",
        query: {
          template: 1,
          file: vm.templateData.sign_document,
        },
      });
      return;



      //       this.templateData.recipients = this.list.map((i) => {
      //         return  i.data.email;
      //       });


      //       this.templateData.names = this.list.map((i) => {
      //         return  {email:i.data.email,name:i.data.name};
      //       });

      //         this.templateData.approvers.initial = this.list2.map((i) => {
      //         return  i.data.email;
      //       });

      //              this.templateData.approvers.final = this.list3.map((i) => {
      //         return  i.data.email;
      //       });

      //       this.templateData.in_order = this.anyOrder;

      //       axios({
      //         method: "post",
      //         url: "/sign/transaction",
      //         baseURL: process.env.VUE_APP_BASE_API,
      //         headers: {
      //           // "Content-Type": "multipart/form-data",
      //           Authorization:
      //             "Bearer " + Vue.prototype.$userData.tokens.access.token,
      //         },
      //         data: this.templateData,
      //       })
      //         .then((response) => {
      //           console.log("SUCCESS!!");

      //        localStorage.setItem(
      //             "transactionId",
      //           response.data.transactionId
      //           );
      // console.log(response);



      //           const reader = new FileReader();
      //           reader.readAsDataURL(this.singpdf);
      //           reader.onload = function () {
      //             localStorage.setItem("pdfFile", reader.result);
      //             vm.$router.push("edit");
      //           };
      //         })
      //         .catch(function (err) {
      //           console.error(err);
      //           if(vm.tryAgain){

      //             vm.goToEdit()
      //           }else{

      //             vm.errorMsg='Error creating the signature transaction';
      //           vm.showError=true;
      //           }
      //         });
    },
    saveTemplate(goToAddFields) {
      var vm = this;
      this.templateData.in_order = this.anyOrder;

      if (vm.editTemplateId) {

        axios({
          method: "put",
          url: "/template/template",
          baseURL: process.env.VUE_APP_BASE_API,
          headers: {
            Authorization:
              "Bearer " + Vue.prototype.$userData.tokens.access.token,
          },
          params: {
            templateId: vm.editTemplateId,
          },
          data: {
            ...this.templateData,
            id: undefined
          },
        })
          .then(() => {
            console.log("SUCCESS!!");

            if (goToAddFields) {

              var fakeUsers = [];
              for (let index = 0; index < vm.templateData.recipients; index++) {
                fakeUsers.push({
                  email: vm.templateData.recipientNames[index] || ('User ' + (index + 1))
                })

              }
              localStorage.setItem(
                "recipients",
                JSON.stringify(
                  fakeUsers
                )
              );
              console.log('templateData.fields');
              console.log(vm.templateData.fields);
              localStorage.setItem(
                "templateFields",
                JSON.stringify(
                  vm.templateData.fields
                )
              );
              //  vm.$router.push("edit");
              vm.$router.push({
                path: "edit",
                query: {
                  template: vm.editTemplateId,
                  file: vm.templateData.sign_document,
                },
              });

            } else {
              vm.$router.push({
                path: "templateManager",
              });
            }
          })
          .catch(function (err) {
            console.log("put FAILURE!!");
            console.error(err);
          });
      } else {
        localStorage.setItem(
          "templateFields",
          JSON.stringify(
            []
          )
        );

        axios({
          method: "post",
          url: "/template/template",
          baseURL: process.env.VUE_APP_BASE_API,
          headers: {
            // "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " + Vue.prototype.$userData.tokens.access.token,
          },
          data: this.templateData,
        })
          .then((response) => {
            console.log("SUCCESS!!");


            console.log(response);
            if (goToAddFields) {

              var fakeUsers = [];
              for (let index = 0; index < vm.templateData.recipients; index++) {
                fakeUsers.push({
                  email: vm.templateData.recipientNames[index] || ('User ' + (index + 1))
                })

              }
              localStorage.setItem(
                "recipients",
                JSON.stringify(
                  fakeUsers
                )
              );
              //  vm.$router.push("edit");
              vm.$router.push({
                path: "edit",
                query: {
                  template: response.data.templateId,
                  file: vm.templateData.sign_document,
                },
              });

            } else {
              vm.$router.push({
                path: "templateManager",
              });
            }

          }).catch(function (err) {
            console.error(err);

          });
      }



    },
    openEmailDialog(data, list, assignColor) {
      this.showEmailDialog = true;
      this.activeList = list;
      this.assignColor = !!assignColor;
      this.emailDialogEditMode = !!data;
      if (!data) {
        this.emailDialogData = {
          name: "",
          email: "",
        };
      } else {
        this.emailDialogDataInit = data;
        this.emailDialogData = {
          name: data.name,
          email: data.email,
        };
      }
    },
    editItem() {
      this.emailDialogDataInit.name = this.emailDialogData.name;
      this.emailDialogDataInit.email = this.emailDialogData.email;
      this.showEmailDialog = false;
    },
    addItem(li, assignColor) {
      const vm = this;
      var list = li || vm.list;
      var length = list.length;
      var color;
      if (assignColor) {
        color = vm.colors.shift();
      }
      list.push({
        name: "",
        order: length + 1,
        id: length + 3,
        email: [],
        data: {
          name: vm.emailDialogData.name,
          email: vm.emailDialogData.email,
        },
        color: color,
        valid: false,
      });
      this.showEmailDialog = false;
    },
    addItem2() {
      const vm = this;
      var length = vm.list2.length;
      vm.list2.push({
        name: "",
        order: length + 1,
        id: length + 3,
        email: [],
        valid: false,
      });
    },
    deleteItem(listItem, li) {
      const vm = this;
      var list = li || vm.list;
      const oldIndex = list.indexOf(listItem);

      if (oldIndex > -1) {
        list.splice(oldIndex, 1);
        if (listItem.color) {
          vm.colors.push(listItem.color);
        }
      }
    },
    onClickEmail(listItem) {
      if (!listItem.valid) {
        listItem.email = [];
      }
    },
    onDeleteEmail(listItem) {
      listItem.valid = false;
    },
    onAddEmail(listItem) {
      const email = listItem.email[0];
      listItem.valid = emailRegex.test(email);
    },
    formatCC(str) {
      const strLower = String(str).toLowerCase();
      return emailRegex.test(strLower) ? strLower : false;
    },
    formatEmail(str) {
      return String(str).toLowerCase();
    },
    sortInit() {
      this.list = this.list.sort((a, b) => a.id - b.id);
    },
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },
    onFocusOrderInput(event) {
      const vm = this;
      vm.changedItem = vm.list.find((item) => {
        return item.order == event.target.value;
      });
    },
    onChangeOrderInput(event) {
      const vm = this;
      var newValue = event.target.value;

      if (newValue <= 1) {
        newValue = 1;
      } else if (newValue > vm.list.length) {
        newValue = vm.list.length;
      }
      newValue--;

      const oldIndex = vm.list.indexOf(vm.changedItem);

      if (oldIndex > -1) {
        vm.list.splice(oldIndex, 1);
      }

      vm.list.splice(newValue, 0, vm.changedItem);

      for (let index = 0; index < vm.list.length; index++) {
        vm.list.order = index + 1;
      }
    },
  },
  computed: {},
  created() {
    localStorage.setItem('appliedTemplate', 'false');
    this.getPermission('templates');
  }
};
</script>

<style lang="scss">
.tab-title {
  color: #a5a5a5;
  margin-bottom: 30px;
}

.send {
  margin: 10px;
}

.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0;
}

.drag-super-cont {
  min-width: 400px;
  width: 70%;
  margin: auto;
  margin-bottom: 50px;
}

.list-group {
  min-height: 20px;
  list-style-type: none;
  padding-left: 0;
  position: relative;
}

.add-btn-text {
  position: absolute;
  right: 50px;
  margin-top: 6px;
  font-weight: bold;
  color: #e94e1b;
}

.drag-disabled {
  cursor: default !important;
}

.list-group-item {
  cursor: move;
  display: flex;
  border: 1px solid #ccc;
  margin-bottom: 10px;

  .order {
    display: flex;
    padding-left: 10px;
    border-right: 1px solid #ccc;
    transition: all 1s ease;
    width: 67px;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.25em;
      color: #ccc;
      transition: all 1s ease;
      opacity: 1;
    }

    .order-input-cont {
      width: 30px;
    }

    .order-input {
      font-size: 1.25em;
      color: #ccc;
      background: none;
      border: none !important;
      width: 30px;

      &:focus {
        outline: none;
      }
    }

    .material-icons {
      margin-right: 5px;
      font-size: 1.5em;
      width: 21px;
    }
  }

  .any-order {
    width: 0;
    padding-left: 0;

    span {
      width: 0;
      margin: 0;
      opacity: 0;
    }
  }

  .md-chips.md-field {
    padding-top: 5px;
    width: 80%;
    margin: 0 10px;
    min-height: 40px;

    &:after {
      background: none;
    }
  }
}

div.order-switch:not(.any-order-switch) span,
.order-switch .md-switch.md-checked .md-switch-label {
  color: #0065ba;
  font-weight: bold;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.order-switch {
  display: flex;

  span {
    margin-right: 16px;
  }

  .md-switch {
    margin: 0;
  }
}

.align-right-btn {
  float: right;
  top: -10px;
  right: -10px;
}

.md-invalid {
  .md-chip {
    background-color: #ff5252;
    color: #fff;
  }
}

.cc-title {
  margin-bottom: 0;
  margin-top: 40px;
}

a.contunue {
  color: white !important;
  text-decoration: none !important;
}

.md-tooltip {
  height: 32px;
  font-size: 14px;
  line-height: 32px;
}
</style>